module.exports = __webpack_public_path__ + "static/img/5.8fc599a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/5.jpg
// module id = A/ko
// module chunks = 1